import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { TenantService } from 'src/app/services/tenant.service';
import { TenantLocalService } from 'src/app/services/tenantlocal.service';
import { UserService } from 'src/app/services/user.service';
import { UsuariotenantService } from 'src/app/services/usuariotenant.service';
import { Swal2 } from 'src/app/utils/swal2.util';
declare var $: any;

@Component({
  selector: 'adp-tenant-dialog',
  templateUrl: './tenant-dialog.component.html',
  styleUrls: ['./tenant-dialog.component.scss']
})
export class TenantDialogComponent {
  tenants: any[] = [];
  selectedTenant: string = '';
  filteredTenants: any[] = [];
  user: any;
  tenant: any = {};
  loadingButton: boolean = false; //cargar spinner
  isLoadingData: boolean = true; // Indica si los datos están siendo cargados

  constructor(
    private usuariotenantService: UsuariotenantService,
    private tenantService: TenantService,
    private userService: UserService,
    private tenantlocalservice: TenantLocalService,
    private router: Router,
    private swal: Swal2,
    public dialogRef: MatDialogRef<TenantDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {
      user: any,
      tenant: any,
    }
  ) {
    this.user = data.user;
    this.tenant = data.tenant
  }

  ngOnInit(): void {
    this.isLoadingData = true; 
    this.tenants = this.user.tenants;
    this.filteredTenants = [...this.tenants];

    this.selectedTenant = this.tenantlocalservice.getTenantSlug() || '';

    this.setTenantInBackend(this.selectedTenant);
    this.isLoadingData = false;
    console.log(this.selectedTenant);
    
    setTimeout(() => {
      this.configureSelect2();
      $('#tenantSelect').val(this.selectedTenant).trigger('change');
    }, 0);
  }

  configureSelect2() {
    $('#tenantSelect').select2({
      width: '100%',
      placeholder: 'Seleccione una empresa',
      allowClear: true,
      minimumResultsForSearch: 0,
      dropdownParent: $('.modal-body'),
      language: {
        noResults: function () {
          return "No se encontraron resultados";
        }
      }
    });

    $('#tenantSelect').on('select2:select', (e: any) => {
      this.selectedTenant = e.params.data.id;
    });

    $('#tenantSelect').on('select2:clear', () => {
      this.selectedTenant = '';
    });
  }

  onConfirm(): void {
    const slug = this.selectedTenant;
    this.loadingButton = true;

    this.tenantlocalservice.setTenantSlug(slug);
    this.setTenantInBackend(slug).subscribe({
      next: () => {
        this.loadingButton = false;
        this.dialogRef.close();
        window.location.reload();
      },
      error: (err) => {
        this.loadingButton = false;
        this.dialogRef.close();
      }
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }

  setTenantInBackend(tenantId: string) {
    return this.tenantService.setTenantInBackend(tenantId).pipe(
      tap({
        next: (response) => {
          this.tenantlocalservice.setTenant(response.tenant);
          this.userService.savePermisosRolesInLocalStorage(response);
          this.router.navigateByUrl('/home');
        },
        error: (err) => {
          console.error('Error al seleccionar tenant en backend:', err);
        }
      })
    );
  }
}